var exports = {
  "k": "x8b4e8595--a8ba7b--container",
  "S": "x8b4e8595--a8ba7b--image",
};

module.exports = exports;
